import React from 'react';
import LeadAttendanceApp from './components/attendance/LeadAttendanceApp';
import { LeadAttendanceProvider } from './context/LeadAttendanceContext';

/**
 * Giveful Lead Attendance PWA
 *
 * Flow:
 * 1. Lead authentication using 8-digit lead code
 * 2. Group selection when the lead manages multiple groups
 * 3. Dashboard with tabs: Attendance, Members, and Stats
 */

function App() {
  return (
    <LeadAttendanceProvider>
      <LeadAttendanceApp />
    </LeadAttendanceProvider>
  );
}

export default App;
